import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom";
import { IWidgetComponent } from "./IWidgetComponent";
import { WidgetImage } from "../Widgets/WidgetImage";
import { LanguageString } from "../../../Model/LanguageString";
import { app } from "../../../Frame/App";

export type WidgetImageComponentProps = {
    widget: WidgetImage;
}

export class WidgetImageComponent extends JSXComponent implements IWidgetComponent {
    props: WidgetImageComponentProps;

    constructor(props: WidgetImageComponentProps) {
        super(props);
    }

    public element: HTMLElement =
        <div className="widget Background-Blur-90-MSO">
            <div className="title-row">
                <div className="title mr-auto">{(this.props.widget.props.title[`value${app.languageUpperCase}`] && this.props.widget.props.title[`value${app.languageUpperCase}`].trim().length > 0) ? this.props.widget.props.title[`value${app.languageUpperCase}`] : this.props.widget.props.title[`value${app.defaultLanguageUpperCase}`]}</div>
            </div>
            <div className="content-row">
                <div className="h-100 py-1 pr-1 d-flex justify-content-center align-items-center">
                    <div className="widget-image h-100"> {this.props.widget.showImage()}</div>
                </div>
            </div>
        </div>;

   

    public render(): HTMLElement {
        this.props.widget.setGridPosition();
        return this.element;
    }
}